import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import SecondaryButton from "../common/buttons/SecondaryButton";

import { IconToggle } from "../../assets/icons/icon-toggle-chat";
import PatientJourney from "./patient-journey";
import { IconSend } from "../../assets/icons/icon-send";
import { IconToggleClose } from "../../assets/icons/icon-toggle-chat-close";
import { fetchUserProfile } from "../../reducer/slices/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import NoConversation from "../../assets/images/no-conversation-vector.svg";
import {
  convertTimeToLocation,
  getBrowserTimeZone,
} from "../common/constant/constant";
import AddEventContainer from "./add-event/add-event-container";
import { getWorkflowTrialById } from "../../reducer/slices/workflow/get-workflow-by-id";
import { getTrialById } from "../../js/api/events";
import { CallIconHover } from "../../assets/icons/call-icon-hover";
import { CallIcon } from "../../assets/icons/call-icon";
import { AddNotesIcon } from "../../assets/icons/add-notes";
import { AddEventsIcon } from "../../assets/icons/add-events";
import { AddNotesHoverIcon } from "../../assets/icons/add-notes-hover";
import { AddEventsHoverIcon } from "../../assets/icons/add-events-hover";
import { IconToggleHover } from "../../assets/icons/icon-toggle-chat-hover";
import { IconToggleCloseHover } from "../../assets/icons/icon-toggle-chat-close-hover";
import CallSuccessNotice from "./call-log/call-success-notice";
import MissedCallNotice from "./call-log/missed-call-notice";
import Docusing from "../../assets/icons/docusing";
import { Toast } from "../common/toast/toast";
import Modal from "../common/modal/modal";
import {
  docuSignStatusClass,
  docuSingStatusMapping,
} from "../../js/api/constants";
import DocuSingDeliver from "../../assets/icons/docusing-deliver";
import DocuSingSent from "../../assets/icons/docusing-sent";
import StatusPatientChange from "./status-change-patient";
import AllowedAccess, { hasAccess } from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";

const statusClasses = {
  All: "bg-[#536493]",
  "In Progress": "bg-[#6F6EDE]",
  "Action Required": "bg-[#F26666]",
  "Requested Follow Up": "bg-[#FABC3F]",
  Qualified: "bg-[#15B392]",
  Booked: "bg-[#66D062]",
  "DNQ Criteria Not Met": "bg-[#CBA35C]",
  "DNQ Other": "bg-[#CBA35C]",
  "DNQ No Response": "bg-[#CBA35C]",
  "DNQ Not Interested": "bg-[#CBA35C]",
  "Non-textable": "bg-[#D73A60]",
  "To-call": "bg-[#605EA1]",
  "Contact Attempt 1": "bg-[#F28E58]",
  "Contact Attempt 2": "bg-[#F28E58]",
  "Contact Attempt 3": "bg-[#F28E58]",
  "Scheduled Screen": "bg-[#AA5486]",
};

const ChatTrialBody = ({
  trialInfo,
  conversation,
  id,
  setLatestmessage,
  onMessageSend,
  handleCall,
}) => {
  const [toasts, setToasts] = useState([]);
  const [getAllTStatus, setGetAllTStatus] = useState([]);
  const [isNoteHover, setIsNoteHover] = useState(false);
  const [isEventHover, setIsEventHover] = useState(false);
  const [isDocuSingModalOpen, setIsDocuSingModalOpen] = useState(false);
  const [isDocuSingLoader, setIsDocuSingLoader] = useState(false);
  const isCallInProgress = useSelector((state) => state.call.callData);
  const callViewSize = useSelector((state) => state.callView.callSizeData);
  const [error, setErrors] = useState({})
  const [txtReasonList, setTxtReasonList] = useState([]);



  const formatTime = (timeString) => {
    const formattedTime = dayjs(timeString).format("MM/DD [at] hh:mm A");
    return formattedTime;
  };
  const [isCalenderRecriuterLoading, setIsCalenderRecriuterLoading] = useState(true);
  const [isCallHover, setIsCallHover] = useState(false);
  const user = useSelector((state) => state.user);
  const formatTimelocaltime = (timeString) => {
    const date = new Date(timeString); // Input is expected to be in UTC
    const timeZone = getBrowserTimeZone();
    const options = {
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone,
    };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(date);

    const month = parts.find((p) => p.type === "month").value;
    const day = parts.find((p) => p.type === "day").value;
    const hour = parts.find((p) => p.type === "hour").value;
    const minute = parts.find((p) => p.type === "minute").value;
    const period = parts.find((p) => p.type === "dayPeriod").value;

    return `${month}/${day} at ${hour}:${minute} ${period}`;
  };
  const chatContainerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const { userProfile, isLoading } = useSelector((state) => state.user);

  const dispatch = useDispatch();


  const getPredefinedNotes = async () => {
    await axios.get(ENDPOINTS.CONVERSATION.GET_NOTES)
      .then((res) => {
        if (res.data?.data?.length > 0) {
          setTxtReasonList(res.data.data);
        }
      });
  };

  useEffect(() => {
    dispatch(fetchUserProfile({}));
    getPredefinedNotes();
  }, []);

  const [chatMessages, setChatMessages] = useState([]);

  const [isAgentOn, setIsAgentOn] = useState(false);

  useEffect(() => {
    // Initialize chatMessages from conversation on first load
    if (conversation && conversation.length > 0) {
      setChatMessages([...conversation]);
    }
  }, [conversation]);

  useEffect(() => {
    setIsAgentOn(trialInfo?.isChatByBot === "True" ? true : false);
  }, [trialInfo]);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  // Check if user is at the bottom of the chat
  const handleScroll = () => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        chatContainerRef.current;
      setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 10);
    }
  };

  // Auto-scroll only if the user is at the bottom
  useEffect(() => {
    if (isAtBottom) {
      scrollToBottom();
    }
  }, [chatMessages]); // Runs only when messages update

  const [isOpen, setIsOpen] = useState(false);
  const AddNote = () => {
    setIsOpen(!isOpen);
    setErrors({});
    setText("");
  };
  const closePopup = () => {
    setIsOpen(false);
  };

  const [text, setText] = useState("");

  const handleNoteChange = (e) => {
    if (e.target.value.length <= 500) {
      setText(e.target.value);
    }
  };

  // to get time

  const getCurrentTime = () => {
    const now = new Date();
    return now.toISOString(); // Returns time in "2025-01-09T07:56:09.18" format
  };

  const [recMessage, setRecMessage] = useState("");

  const sendMessage = async () => {
    const currentTime = getCurrentTime();

    try {
      const response = await axios.post(ENDPOINTS.CONVERSATION.SEND_MESSAGE, {
        userMessage: recMessage,
        toPhoneNumber: trialInfo.phoneNumber,
        sessionId: id,
      });

      setRecMessage("");

      if (response.status === 200) {
        const sentMessage = {
          msgContent: recMessage,
          lastContacted: currentTime,
          messageAt: currentTime,
          recruiterName: `${userProfile.firstName} ${userProfile.lastName}`,
        };

        setLatestmessage(sentMessage);

        if (onMessageSend) {
          onMessageSend();
        }

        setChatMessages((prevMsg) => [...prevMsg, sentMessage]);
      } else {
        console.error("Error sending message:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  const AddNoteToChat = async (e) => {
    const currentTime = getCurrentTime();

    if (!text) {
      setErrors({ txtReason: "Please enter the reason." });
      return;
    }

    try {
      const response = await axios.post(
        `${ENDPOINTS.CONVERSATION.ADD_NOTE}?patientTrialJuncId=${id}&note=${text}`
      );

      if (response.status === 200) {
        const addNote = {
          msgContent: text,
          sender: "NoteRecruiter",
          recruiterName: `${userProfile.firstName} ${userProfile.lastName}`,
          createdAt: currentTime,
        };
        setText("");
        setIsOpen(false);
        setChatMessages((prevMsg) => [...prevMsg, addNote]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [togglePj, setTogglePj] = useState(true);
  const [togglePjHover, setTogglePjHover] = useState(false);
  // get initials
  const getInitials = (name) => {
    return name
      .split(" ") // Split the name into words
      .map((word) => word[0].toUpperCase()) // Take the first letter of each word and capitalize it
      .join(""); // Join the initials together
  };
  // get initials Ends -------------------------

  const truncate = (text = "", limit = 0) => {
    if (typeof text !== "string") return "";
    return text.length > limit ? text.slice(0, limit).trimEnd() + "..." : text;
  };


  const updateAgentControl = async (value) => {
    let queryParams = {
      patientTrialJuncId: id,
      isChatByBot: value,
    };

    await axios
      .put(
        ENDPOINTS.CONVERSATION.UPDATE_PATIENT_CONVERSATION_CONTROL,
        {},
        { params: queryParams }
      )
      .then((res) => {
        // handle success
      });
  };

  // Add events
  const [isAddEventOpen, setIsAddEventOpen] = useState(false);
  const [addEventId, setAddEventId] = useState(false);
  const [trialRecruiter, setTrialRecruiter] = useState(null);
  const [recruiterData, setRecruiterData] = useState(
    trialRecruiter &&
    trialRecruiter.assignedRecruiter &&
    trialRecruiter.assignedRecruiter.filter((val) => val.hasCalendar)
  );
  const [operationalData, setOperationalData] = useState(
    trialRecruiter &&
    trialRecruiter.operatingHoursJson &&
    trialRecruiter.operatingHoursJson
  );
  const hasFetchedTrialRef = useRef(false);
  const fetchTrialDataByIdFunc = (id) => {
    if (hasFetchedTrialRef.current) return;

    // Basic condition check
    if (
      !trialRecruiter ||
      (recruiterData && !recruiterData.length) ||
      (operationalData && operationalData.length)
    ) {
      setIsCalenderRecriuterLoading(true);
    }

    getTrialById({ id })
      .then((trial) => {
        setTrialRecruiter(trial.data);
        setRecruiterData(
          trial?.data?.assignedRecruiter?.filter((val) => val.hasCalendar)
        );
        setOperationalData(trial?.data?.operatingHoursJson);
        setIsCalenderRecriuterLoading(false);
        hasFetchedTrialRef.current = true; // Mark as fetched
      })
      .catch((err) => {
        setIsCalenderRecriuterLoading(false);
        console.error("Failed to fetch trial:", err);
      });
  };

  useEffect(() => {
    const id = addEventId;
    fetchTrialDataByIdFunc(id);
  }, [addEventId]);

  const openAddEvent = () => {
    setAddEventId(trialInfo.trialID);

    setTimeout(() => {
      setIsAddEventOpen(!isOpen);
    }, 500);

  };

  const closeAddEvent = () => {
    setIsAddEventOpen(false);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const sendDocument = async () => {
    let params = {
      patientID: trialInfo.patientID,
    };
    setIsDocuSingLoader(true);
    await axios
      .post(ENDPOINTS.DOCUSIGN.SEND_DOCUMENT, params)
      .then((res) => {
        addToast(
          res.data.data.message,
          res.data.data.isSuccess ? "success" : "error"
        );
      })
      .finally(() => {
        setIsDocuSingModalOpen(false);
        setIsDocuSingLoader(false);
      });
  };

  const handleDocuSingaction = () => {
    setIsDocuSingModalOpen(true);
  };

  useEffect(() => {
    const id = addEventId;
    dispatch(getWorkflowTrialById({ id }));
  }, [addEventId]);

  const getAllTrialStatus = async () => {
    const response = await axios
      .get(ENDPOINTS.TRIALS.GET_ALL_TRIAL_STATUS)
      .then((res) => {
        setGetAllTStatus(res.data.data.items);
      });
  };

  const updateTrialStatus = async (value) => {
    try {
      const response = await axios.put(
        `${ENDPOINTS.TRIALS.CHANGE_PATIENT_STATUS}?patientTrialJuncId=${trialInfo.patientTrialJuncID}&statusName=${value.normalizedStatus}`
      );
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        typeof error.response.data.message === "string"
      ) {
        addToast(error.response.data.message, "error");
      }
    }
  }

  useEffect(() => {
    getAllTrialStatus();
  }, []);

  const NoteRecruiterMessage = ({ message }) => (
    <div className="flex justify-end mb-4 text-right">
      <div className="w-auto max-w-lg">
        <div className="flex justify-end items-center">
          <span className="text-[16px] font-medium px-3 py-2 text_color">
            {message.recruiterName || "AI Assistant"}
          </span>
        </div>
        <div
          className="text-[14px] text-left p-2 bg-[#FFF7DD] border rounded-lg text_color break-words"
          style={{ borderColor: "#FFC95C" }}
        >
          <span className="font-medium">Note: </span>
          <span>{message.msgContent}</span>
        </div>
        <span className="text-xs text-right text-[#667783] py-3 block">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  const DocuSignMessage = ({ message }) => (
    <div className="flex justify-end mb-4 text-right">
      <div className="max-w-lg">
        <div className="flex justify-end items-center">
          <span className="text-[16px] font-medium px-3 py-2 text_color">
            {message.recruiterName || "Epic Medical Research"}
          </span>
        </div>
        <div
          className="text-[14px] text-left p-2 bg-[#dde9ff] border rounded-lg text_color"
          style={{ borderColor: "#5d76e2" }}
        >
          <span className="font-medium">{message.msgContent}</span>
        </div>
        <span className="text-xs text-right text-[#667783] py-3 block">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  const PatientMessage = ({ message, patientName }) => (
    <div className="flex justify-start mb-4">
      <div className="max-w-lg" style={{ borderColor: "#E7E7E7" }}>
        <p className="text-[16px] font-medium text_color px-3 py-2 text-left">
          {patientName}
        </p>
        <p
          className="text-[16px] py-[16px] px-[24px] bg-white border"
          style={{ borderRadius: "0 14px 14px 14px", borderColor: "#E7E7E7" }}
        >
          {message.msgContent}
        </p>
        <span className="text-xs text-[#667783] p-3 block text-left">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  const GenericMessage = ({ message }) => (
    <div className="flex justify-end mb-4">
      <div className="max-w-lg">
        <p className="text-[16px] font-medium text_color px-3 py-2 text-right">
          {message.recruiterName || "AI Assistant"}
        </p>
        <p
          className="text-[16px] py-[16px] px-[24px] bg-[#278EFF] text-white"
          style={{ borderRadius: "14px 0 14px 14px" }}
        >
          {message.msgContent}
        </p>
        <span className="text-xs text-[#667783] p-3 block text-right">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  useEffect(() => {
    if (isCallInProgress && !callViewSize.isMinView) {
      setIsAddEventOpen(false)
    }
  }, [callViewSize]);

  return conversation && conversation.length === 0 ? (
    <div
      className="h-[calc(100vh-80px)] w-full flex flex-col items-center justify-center no-conversation actual-img-ratio border-l bg-[#ffffff]"
      style={{ borderColor: "#C8D6E6" }}
    >
      <img src={NoConversation} alt="" />
      <p className="mt-1 text-sm font-medium">No Conversations yet</p>
    </div>
  ) : (
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}

      <div
        className="flex-1 flex flex-col border-l overflow-hidden"
        style={{ borderColor: "#C8D6E6" }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between p-4 bg-white border-b"
          style={{ borderColor: "#C8D6E6" }}
        >
          <div className="flex items-center space-x-2 w-full justify-between">
            <div className="text-left flex items-center justify-between">
              <span className="font-semibold ml-[13px] text-[20px] title_color">
                {trialInfo.trialName} -
              </span>
              <div className="mr-4 pr-4 text-[16px]">
                <div class="relative inline-block text-left mr-3">
                  <StatusPatientChange
                    CanChange={hasAccess(user, [PermissionList.trials_hub.change_trial_patient_status])}
                    className={'absolute top-[35px] left-[-20px]'}
                    options={getAllTStatus}
                    initialValue={trialInfo?.status}
                    onSelect={(selectedOption) => {
                      updateTrialStatus(selectedOption);
                    }}
                  />
                </div>

              </div>
            </div>
            <div className="flex ">
              <div className="relative group inline-block">
                <button
                  disabled={isCallInProgress}
                  onClick={() => {
                    // setCallingModal(trialInfo.phoneNumber);
                    handleCall(trialInfo.phoneNumber);
                    // setIsChat(false);
                  }}
                  className={
                    isCallInProgress ? `cursor-not-allowed p-0` : `p-0`
                  }
                  onMouseEnter={() => setIsCallHover(true)}
                  onMouseLeave={() => setIsCallHover(false)}
                >
                  {isCallHover ? <CallIconHover /> : <CallIcon />}
                </button>

                {/* Tooltip */}
                <div
                  className="absolute top-full left-1/2 -translate-x-1/2 mt-2 
                opacity-0 group-hover:opacity-100 transition-opacity duration-200 
                bg-white text-[#1A1A1B] border border-[#E4E4E4] 
                text-xs px-2 py-1 rounded z-50 whitespace-nowrap 
                w-[42px] h-[32px] flex items-center justify-center tooltip"
                >
                  {isCallInProgress ? "Call In Progress" : "Call"}
                </div>
              </div>

              <div className="border-r mx-4 border-[#C8D6E6] "></div>

              <div className=" relative group group-icon text-right justify-end flex border-r pr-4" style={{ borderColor: "#e3eaf2" }}>
                <label
                  className={`relative inline-flex items-center h-6 w-12 rounded-full cursor-pointer border border-[#A6A6A6] ${isAgentOn ? "bg-blue-500 border-blue-500" : "bg-[#ffffff]"
                    }`}
                >
                  <input
                    type="checkbox"
                    checked={isAgentOn}
                    className="hidden"
                    onChange={(e) => {
                      setIsAgentOn(!isAgentOn);
                      updateAgentControl(!isAgentOn);
                    }}
                  />
                  <span
                    className={`inline-block h-[18px] w-[18px] bg-[#A6A6A6] rounded-full transform transition-transform ${isAgentOn ? "translate-x-6 bg-white" : "translate-x-1"
                      }`}
                  ></span>
                </label>
                <span className="tooltip bottom-full transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity">
                  {isAgentOn ? "Off" : "On"} AI Assistance
                </span>

                <p
                  className="mr-4 border-r pr-4 text-[16px]  border-[#C8D6E6]"
                // style={{ borderColor: "#e3eaf2" }}
                >
                  {/* <span className="font-semibold">Trial: </span>{trialName.trialName && truncate(trialName.trialName, 30)}  */}
                </p>
              </div>
              <AllowedAccess permissions={[PermissionList.conversations.chat_details]}>
                <div className="relative group group-icon">
                  <span
                    className={
                      togglePj
                        ? "expandPf cursor-pointer"
                        : "collapsePf cursor-pointer"
                    }
                    onClick={() => setTogglePj(!togglePj)}
                    onMouseEnter={() => {
                      setTogglePjHover(true);
                    }}
                    onMouseLeave={() => {
                      setTogglePjHover(false);
                    }}
                  >
                    {togglePj ? (
                      togglePjHover ? (
                        <IconToggleHover />
                      ) : (
                        <IconToggle />
                      )
                    ) : togglePjHover ? (
                      <IconToggleCloseHover />
                    ) : (
                      <IconToggleClose />
                    )}
                  </span>
                  <span className="tooltip bottom-full transform -translate-x-full opacity-0 group-hover:opacity-100 transition-opacity">
                    Chat Details
                  </span>
                </div>
              </AllowedAccess>
            </div>
          </div>
        </div>
        <div className="chatBodyPart flex justify-between flex-row bg-[#F5F5F5]  h-[calc(100vh-155px)]">
          <div className="chatBodyLeft flex flex-col h-full  w-full">
            {/* Chat Messages */}
            <div
              className="flex-1 overflow-y-auto p-4"
              id="liveChatMessages"
              ref={chatContainerRef}
              onScroll={handleScroll}
            >
              {/* {chatMessages?.map((message, index) =>
              message.sender === "NoteRecruiter" ? (
                <>
                  <div className="flex justify-end mb-4 text-right">
                    <div className="w-auto">
                      <div className="flex justify-end items-center">
                        <span className="text-[16px] font-medium px-3 py-2 text_color">
                          {message.recruiterName
                            ? message.recruiterName
                            : "AI Assistant"}
                        </span>
                      </div>
                      <div
                        className="text-[14px] text-left p-2 bg-[#FFF7DD] border rounded-lg text_color"
                        style={{ borderColor: "#FFC95C" }}
                      >
                        <span className="font-medium">Note: </span>
                        <span> {message.msgContent}</span>
                      </div>
                      <span className="text-xs text-right text-[#667783] py-3">
                        {message.condition
                          ? formatTimelocaltime(message.createdAt)
                          : formatTime(
                            convertTimeToLocation(message.createdAt)
                          )}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <div
                  key={index}
                  className={`flex ${message.sender === "Patient"
                    ? "justify-start"
                    : "justify-end"
                    } mb-4`}
                >
                  <div
                    className="max-w-lg"
                    style={{
                      borderColor:
                        message.sender === "Patient" ? "#E7E7E7" : "none",
                    }}
                  >
                    <p
                      className={`text-[16px] font-medium text_color px-3 py-2   ${message.sender === "Patient"
                        ? "text-left"
                        : "text-right"
                        }`}
                    >
                      {message.sender === "Patient"
                        ? trialInfo.patientName
                        : message.recruiterName
                          ? message.recruiterName
                          : "AI Assistant"}
                    </p>
                    <p
                      className={`text-[16px]  py-[16px] px-[24px] ${message.sender === "Patient"
                        ? "bg-white border"
                        : "bg-[#278EFF] text-white "
                        }`}
                      style={{
                        borderRadius:
                          message.sender === "Patient"
                            ? "0 14px 14px 14px"
                            : "14px 0 14px 14px",
                        borderColor:
                          message.sender === "Patient" ? "#E7E7E7" : "none",
                      }}
                    >
                      {message.msgContent}
                    </p>
                    <span
                      className={`text-xs text-[#667783] p-3 block ${message.sender === "Patient"
                        ? "text-left"
                        : "text-right"
                        }`}
                    >
                      {message.condition
                        ? formatTimelocaltime(message.createdAt)
                        : formatTime(convertTimeToLocation(message.createdAt))}
                    </span>
                  </div>
                </div>
              )
            )} */}

              {chatMessages?.map((message, index) => {
                if (message.sender === "NoteRecruiter") {
                  return <NoteRecruiterMessage key={index} message={message} />;
                } else if (message.sender === "DocuSign") {
                  return (
                    <DocuSignMessage
                      key={index}
                      message={message}
                      patientName={trialInfo.patientName}
                    />
                  );
                } else if (message.sender === "Patient") {
                  return (
                    <PatientMessage
                      key={index}
                      message={message}
                      patientName={trialInfo.patientName}
                    />
                  );
                } else if (message.sender === "CallLog") {
                  const msgContent = JSON.parse(message.msgContent);
                  const isCompleted = msgContent.CallStatus === "completed";
                  const isMissedCall = msgContent.CallStatus === "no-answer";
                  return (
                    <div className="flex justify-end mb-4">
                      {isCompleted ? (
                        <CallSuccessNotice msgContent={msgContent} />
                      ) : isMissedCall ? (
                        <MissedCallNotice msgContent={msgContent} />
                      ) : (
                        ""
                      )}
                    </div>
                  );
                } else {
                  return <GenericMessage key={index} message={message} />;
                }
              })}
            </div>

            {/* Message Input */}
            <div
              className="p-4 bg-[#f5f5f5] flex items-center h-[80px]"
              style={{ borderColor: "#C8D6E6" }}
            >
              <div
                className="bg-white w-full flex p-3 border rounded-lg"
                style={{ borderColor: "#C8D6E6" }}
              >

                <AllowedAccess permissions={[PermissionList.conversations.outbound_conversation]}>
                  <textarea
                    placeholder="Type a message"
                    className="w-full border-none outline-none p-2 text-[16px] text-[#87909e] resize-none overflow-hidden leading-tight"
                    value={recMessage}
                    rows={2}
                    style={{
                      height: "40px", // Adjust as per design needs
                      lineHeight: "20px", // Ensure two lines fit within height
                      paddingTop: "6px",
                      paddingBottom: "2px",
                      overflowY: "hidden", // Hide extra content
                      display: "block",
                    }}
                    onChange={(e) => setRecMessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onInput={(e) => {
                      const target = e.target;
                      target.scrollTop = target.scrollHeight; // Ensures last lines stay visible
                    }}
                  />
                  <button
                    className="ml-2 pr-2 pl-1 py-2 bg_blue_color text-white h-[46px] w-[46px] rounded-3xl"
                    onClick={sendMessage}
                  >
                    <span className="-rotate-[5deg] block">
                      <IconSend />
                    </span>
                  </button>
                  <span className="border-r table_border h-[46px] mx-[22px]"></span>
                </AllowedAccess>

                <div className="flex py-1 px-2 gap-4">
                  {/* Add Note Button */}
                  <AllowedAccess permissions={[PermissionList.conversations.conversation_note]}>
                    <div className="relative group">
                      <button
                        className="inline-flex items-center py-1 gap-2 text-[14px] font-[500] text-[#1a1a1b] shadow-sm"
                        onClick={AddNote}
                        onMouseEnter={() => setIsNoteHover(true)}
                        onMouseLeave={() => setIsNoteHover(false)}
                      >
                        {isNoteHover ? <AddNotesHoverIcon /> : <AddNotesIcon />}
                      </button>
                      <span className="absolute -top-10 left-1/2 -translate-x-1/2 w-[76px] h-[30px] whitespace-nowrap px-2 py-[2px] text-[10px] text-center text-black bg-white border border-gray-300 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 font-semibold">
                        <div className="mt-1">Add Note</div>
                      </span>
                    </div>
                  </AllowedAccess>

                  {/* Add Event Button */}
                  <AllowedAccess permissions={[PermissionList.conversations.add_event_to_conversation]}>
                    <div className="relative group">
                      <button
                        className="inline-flex items-center py-1 gap-2 rounded-md text-[14px] font-[500]"
                        onClick={openAddEvent}
                        onMouseEnter={() => setIsEventHover(true)}
                        onMouseLeave={() => setIsEventHover(false)}
                      >
                        {isEventHover ? (
                          <AddEventsHoverIcon />
                        ) : (
                          <AddEventsIcon />
                        )}
                      </button>
                      <span className="absolute -top-10 left-1/2 -translate-x-1/2 w-[90px] h-[30px] whitespace-nowrap px-2 py-[2px] text-[10px] text-center mt-auto text-black bg-white border border-gray-300 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 font-semibold">
                        <div className="mt-1">Add Event</div>
                      </span>
                    </div>
                  </AllowedAccess>

                  {/* Add Docusign Button */}
                  <div className="relative group">
                    <button
                      className="inline-flex items-center py-1 gap-2 rounded-md text-[14px] font-[500]"
                      onClick={handleDocuSingaction}
                    >
                      <Docusing />
                    </button>
                    <span className="absolute -top-10 left-1/2 -translate-x-3/4 w-[120px] h-[30px] whitespace-nowrap px-2 py-[2px] text-[10px] text-center mt-auto text-black bg-white border border-gray-300 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 font-semibold">
                      <div className="mt-1">Send DocuSign Link</div>
                    </span>
                  </div>
                </div>

                {isAddEventOpen && (
                  <AddEventContainer
                    recruiterData={recruiterData}
                    operationalData={operationalData}
                    trialRecruiter={trialRecruiter}
                    trialInfo={trialInfo}
                    isAddEventOpen={isAddEventOpen}
                    openAddEvent={openAddEvent}
                    closeAddEvent={closeAddEvent}
                    toasts={toasts}
                    removeToast={removeToast}
                    setToasts={setToasts}
                  />
                )}
              </div>
            </div>
          </div>{" "}
          {/* End of chatBodyLeft*/}
          <AllowedAccess permissions={[PermissionList.conversations.chat_details]}>
            <div
              className={`chatBodyright transition-all ${togglePj ? "block" : "hidden"
                }`}
            >
              <PatientJourney trialInfo={trialInfo} setTogglePj={setTogglePj} />
            </div>{" "}
          </AllowedAccess>
          {/* End of chatBodyPart*/}
        </div>{" "}
        {/* End of chatBodyPart*/}
        {/* popup for Add Note */}
        {isOpen && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
              <h2>Add Note</h2>

              <div>
                <div className="flex  mt-2 text-sm items-center relative">
                  <select
                    id="rerouteReason"
                    name="rerouteReason"
                    className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                    onChange={handleNoteChange}
                  >
                    <option value={""} selected>
                      Select Reason
                    </option>
                    {txtReasonList && txtReasonList.length > 0 && txtReasonList
                      .map((r) => (
                        <option key={r.noteID} value={r.note}>
                          {r.note}
                        </option>
                      ))}
                  </select>
                  <span className="absolute right-4 top-[25px] transform -translate-y-1/2 pointer-events-none">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                        stroke="#245CEA"
                        strokeWidth="2"
                        stroke-miterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
              </div>

              <textarea
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 mt-5 h-40"
                value={text}
                onChange={handleNoteChange}
                placeholder="Type your text here..."
              ></textarea>

              <div className="flex justify-between items-center my-2">
                <div>

                  {error.txtReason && (
                    <p className="text-[#F95454] font-mont text-[14px] font-[500]">
                      {error.txtReason}
                    </p>
                  )}
                </div>

                <div className="text-sm text-gray-600">
                  {text.length} / 500
                </div>
              </div>

              <button
                onClick={closePopup}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>

              <div className="flex justify-end">
                <button
                  onClick={AddNoteToChat}
                  className="px-5 mr-3 py-1 text-base rounded-md border primary_btn transition-all duration-500"
                >
                  Save
                </button>
                <SecondaryButton onClick={closePopup} label="Cancel" />
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal
        isOpen={isDocuSingModalOpen}
        onClose={() => { }}
        width={trialInfo.docuSignStatus != null ? "max-w-xl" : "max-w-lg"}
      //title="Sample Modal"
      >
        {trialInfo.docuSignStatus == null && (
          <>
            <div className="flex justify-between gap-4">
              <div>
                <div className="w-[45px] h-[45px] rounded-full overflow-hidden flex items-center justify-center bg-[#F1EBFF]">
                  <Docusing />
                </div>
              </div>

              <p className="font-medium">
                Are you sure you want to send and make this Docusing document
                public to the recipent?
              </p>
            </div>

            <div className="mt-6 flex justify-end space-x-2">
              <button
                disabled={isDocuSingLoader}
                onClick={sendDocument}
                className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px]"
              >
                {isDocuSingLoader ? (
                  <div className="flex justify-center">
                    <div className="mini-spinner "></div>
                  </div>
                ) : (
                  "Send"
                )}
              </button>

              <button
                disabled={isDocuSingLoader}
                onClick={() => setIsDocuSingModalOpen(false)}
                className={`px-[20px] py-[10px] text-[14px] font-medium rounded-md border secondary_btn transition-all duration-500`}
              >
                Cancel
              </button>
            </div>
          </>
        )}

        {trialInfo.docuSignStatus != null && (
          <>
            <div className="flex justify-between gap-4">
              <div>
                <div className="w-[45px] h-[45px] rounded-full overflow-hidden flex items-center justify-center bg-[#F1EBFF]">
                  <Docusing />
                </div>
              </div>
              <div>
                <p className="font-medium">
                  The current document status in DocuSign is '
                  {docuSingStatusMapping[trialInfo.docuSignStatus]}' -
                  {docuSingStatusMapping[trialInfo.docuSignStatus] ==
                    "Document Signed" &&
                    " Signature received from the recipient."}
                  {docuSingStatusMapping[trialInfo.docuSignStatus] ==
                    "Document Delivered" && " Document viewed by recipient."}
                  {docuSingStatusMapping[trialInfo.docuSignStatus] ==
                    "Document Sent" && " Document sent to the Patient."}
                </p>

                <p
                  className={`text-xs mt-2 text-gray-500 rounded-3xl px-2 py-2 status-bubble inline-flex gap-2 
                  ${docuSignStatusClass[trialInfo.docuSignStatus]}`}
                >
                  {docuSingStatusMapping[trialInfo.docuSignStatus] ==
                    "Document Delivered" && <DocuSingDeliver />}
                  {docuSingStatusMapping[trialInfo.docuSignStatus] ==
                    "Document Sent" && <DocuSingSent />}

                  {docuSingStatusMapping[trialInfo.docuSignStatus]}
                </p>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-2">
              <button
                onClick={() => setIsDocuSingModalOpen(false)}
                className="px-[20px] py-[10px] text-[14px] text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px]"
              >
                OK
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  ); // last condition of  chatMessages.length
};

export default ChatTrialBody;
